module.exports = __webpack_public_path__ + "img/thumb-fridge-poet.2ae20091.jpg";